/* =========================================================
   File: assets/sh_hero_slider.js
   Website: Capital Floorings
   Purpose:
   - Creative animated hero slider
   - Autoplay, arrows, dots, keyboard support
   - Content entrance/exit animations
========================================================= */

(function () {
  'use strict';

  function initHeroSlider(slider) {
    if (!slider || slider.dataset.initialized === 'true') {
      return;
    }

    slider.dataset.initialized = 'true';

    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-sh-hero-slide]'));
    var prevButton = slider.querySelector('[data-sh-hero-prev]');
    var nextButton = slider.querySelector('[data-sh-hero-next]');
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-sh-hero-dot]'));
    var progress = slider.querySelector('[data-sh-hero-progress]');
    var autoplay = slider.dataset.autoplay === 'true';
    var speed = Number(slider.dataset.speed || 5500);
    var currentIndex = 0;
    var timer = null;
    var isAnimating = false;

    if (!slides.length) {
      return;
    }

    if (Number.isNaN(speed) || speed < 2000) {
      speed = 5500;
    }

    slider.style.setProperty('--sh-hero-progress-time', speed + 'ms');

    function resetProgress() {
      if (!progress) {
        return;
      }

      slider.classList.remove('is-autoplaying');
      progress.style.animation = 'none';

      window.requestAnimationFrame(function () {
        progress.style.animation = '';
        if (autoplay) {
          slider.classList.add('is-autoplaying');
        }
      });
    }

    function setActiveDot(index) {
      dots.forEach(function (dot) {
        dot.classList.remove('is-active');
      });

      if (dots[index]) {
        dots[index].classList.add('is-active');
      }
    }

    function goToSlide(nextIndex) {
      if (isAnimating || nextIndex === currentIndex || !slides[nextIndex]) {
        return;
      }

      isAnimating = true;

      var currentSlide = slides[currentIndex];
      var nextSlide = slides[nextIndex];

      currentSlide.classList.remove('is-active');
      currentSlide.classList.add('is-leaving');

      nextSlide.classList.remove('is-leaving');
      nextSlide.classList.add('is-active');

      setActiveDot(nextIndex);
      currentIndex = nextIndex;
      resetProgress();

      window.setTimeout(function () {
        currentSlide.classList.remove('is-leaving');
        isAnimating = false;
      }, 1150);
    }

    function nextSlide() {
      var nextIndex = currentIndex + 1;

      if (nextIndex >= slides.length) {
        nextIndex = 0;
      }

      goToSlide(nextIndex);
    }

    function prevSlide() {
      var nextIndex = currentIndex - 1;

      if (nextIndex < 0) {
        nextIndex = slides.length - 1;
      }

      goToSlide(nextIndex);
    }

    function startAutoplay() {
      if (!autoplay || slides.length <= 1) {
        return;
      }

      stopAutoplay();

      timer = window.setInterval(function () {
        nextSlide();
      }, speed);

      resetProgress();
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }

      slider.classList.remove('is-autoplaying');
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        prevSlide();
        startAutoplay();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        nextSlide();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = Number(dot.dataset.shHeroDot);

        if (!Number.isNaN(index)) {
          goToSlide(index);
          startAutoplay();
        }
      });
    });

    slider.addEventListener('mouseenter', function () {
      if (slider.closest('[data-pause-on-hover="false"]')) {
        return;
      }

      if (autoplay) {
        stopAutoplay();
      }
    });

    slider.addEventListener('mouseleave', function () {
      if (autoplay) {
        startAutoplay();
      }
    });

    slider.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') {
        nextSlide();
        startAutoplay();
      }

      if (event.key === 'ArrowLeft') {
        prevSlide();
        startAutoplay();
      }
    });

    slider.setAttribute('tabindex', '0');

    window.setTimeout(function () {
      slides[0].classList.add('is-active');
      setActiveDot(0);
      startAutoplay();
    }, 80);
  }

  function initAllHeroSliders() {
    document.querySelectorAll('[data-sh-hero-slider]').forEach(function (slider) {
      initHeroSlider(slider);
    });
  }

  document.addEventListener('DOMContentLoaded', initAllHeroSliders);
  document.addEventListener('shopify:section:load', initAllHeroSliders);
})();
